// import {
//   AuthService,
//   SubscriptionService,
//   UserCopilotQuotaService,
// } from '@affine/core/modules/cloud';
// import { SubscriptionPlan, SubscriptionRecurring } from '@affine/graphql';
// import { Trans, useI18n } from '@affine/i18n';
// import { AfFiNeIcon } from '@blocksuite/icons/rc';
// import { useLiveData, useServices } from '@toeverything/infra';
// import {
//   type ReactNode,
//   type RefObject,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from 'react';

// import { CloudPlanLayout } from './layout';
// import { LifetimePlan } from './lifetime/lifetime-plan';
// import { PlanCard } from './plan-card';
// import * as styles from './style.css';
// import { getEnv } from '@affine/core/modules/cloud/constant';
// import { useCdnConfig } from '@affine/core/components/hooks/use-cdn-config';

// type T = ReturnType<typeof useI18n>;

// export type Benefits = Record<
//   string,
//   Array<{
//     icon?: ReactNode;
//     title: ReactNode;
//     badge?: string;
//   }>
// >;
// type BenefitsGetter = (t: T) => Benefits;
// interface BasePrice {
//   plan: SubscriptionPlan;
//   name: string;
//   description: string;
//   benefits: Benefits;
// }
// export interface FixedPrice extends BasePrice {
//   type: 'fixed';
//   monthlySellingAmount: string;
//   monthlyPrice: number;
//   monthlyOriginalAmount: string;
//   yearlyPrice: number;
//   yearlySellingAmount: string;
//   yearlyOriginalAmount: string;
//   earlyAccessSpecial?: string;
//   monthlyProductId?: number;
//   yearlyProductId?: number;
//   titleRenderer: (
//     recurring: SubscriptionRecurring,
//     detail: FixedPrice
//   ) => ReactNode;
// }

// export interface DynamicPrice extends BasePrice {
//   type: 'dynamic';
//   contact: boolean;
//   monthlySellingAmount: string;
//   monthlyOriginalAmount: string;
//   monthlyPrice: number;
//   yearlySellingAmount: string;
//   yearlyOriginalAmount: string;
//   yearlyPrice: number;
//   earlyAccessSpecial?: string;
//   monthlyProductId?: number;
//   yearlyProductId?: number;
//   titleRenderer: (
//     recurring: SubscriptionRecurring,
//     detail: DynamicPrice
//   ) => ReactNode;
// }

// const freeBenefits: BenefitsGetter = t => ({
//   [t['com.affine.payment.cloud.free.benefit.g1']()]: ([1, 2, 3] as const).map(
//     i => ({
//       title: t[`com.affine.payment.cloud.free.benefit.g1-${i}`](),
//       badge:
//         i === 1
//           ? t[`com.affine.payment.cloud.free.benefit.g1-${i}-badge`]()
//           : '',
//     })
//   ),
// });

// const proBenefits: BenefitsGetter = t => ({
//   [t['com.affine.payment.cloud.pro.benefit.g1']()]: (
//     [1, 2, 3, 4, 5] as const
//   ).map(i => ({
//     title: t[`com.affine.payment.cloud.pro.benefit.g1-${i}`](),
//     badge:
//       i === 1 ? t[`com.affine.payment.cloud.pro.benefit.g1-${i}-badge`]() : '',
//   })),
// });

// const studioBenefits: BenefitsGetter = t => ({
//   [t['com.affine.payment.cloud.studio-workspace.benefit.g1']()]: (
//     [1, 2, 3, 4, 5, 6] as const
//   ).map(i => ({
//     title: t[`com.affine.payment.cloud.studio-workspace.benefit.g1-${i}`](),
//     badge:
//       i === 1
//         ? t[`com.affine.payment.cloud.studio-workspace.benefit.g1-${i}-badge`]()
//         : '',
//   })),
// });

// export function getPlanDetail(t: T) {
//   return new Map<SubscriptionPlan, FixedPrice | DynamicPrice>([
//     [
//       SubscriptionPlan.Free,
//       {
//         type: 'fixed',
//         plan: SubscriptionPlan.Free,
//         monthlySellingAmount: '0',
//         monthlyOriginalAmount: '',
//         yearlySellingAmount: '0',
//         yearlyOriginalAmount: '',
//         monthlyPrice: 0,
//         yearlyPrice: 0,
//         name: t['com.affine.payment.cloud.free.name'](),
//         description: t['com.affine.payment.cloud.free.description'](),
//         titleRenderer: () => {
//           return (
//             <div className={styles.price}>
//               <span className={styles.priceNumber}>$0</span>
//               <span className={styles.priceUnit}>
//                 / {t['com.affine.payment.cloud.pro.title.price-monthly-unit']()}
//               </span>
//             </div>
//           );
//         },
//         earlyAccessSpecial:
//           t['com.affine.payment.cloud.free.earlyAccessSpecial'](),
//         benefits: freeBenefits(t),
//       },
//     ],
//     [
//       SubscriptionPlan.Pro,
//       {
//         type: 'fixed',
//         plan: SubscriptionPlan.Pro,
//         monthlySellingAmount: '1',
//         monthlyOriginalAmount: '',
//         yearlySellingAmount: '1',
//         yearlyOriginalAmount: '',
//         monthlyPrice: 0,
//         yearlyPrice: 0,
//         name: t['com.affine.payment.cloud.pro.name'](),
//         description: t['com.affine.payment.cloud.pro.description'](),
//         earlyAccessSpecial:
//           t['com.affine.payment.cloud.pro.earlyAccessSpecial'](),
//         titleRenderer: (recurring, detail) => {
//           const sellingPrice =
//             recurring === SubscriptionRecurring.Yearly
//               ? detail.yearlySellingAmount
//               : detail.monthlySellingAmount;
//           const originalPrice =
//             recurring === SubscriptionRecurring.Yearly
//               ? detail.yearlyOriginalAmount
//               : detail.monthlyOriginalAmount;

//           const monthlySellingAmount = detail.monthlySellingAmount;
//           return (
//             <div className={styles.price}>
//               {/* {t['com.affine.payment.cloud.pro.title.price-monthly']({
//                 price: '$' + price,
//               })} */}
//               <span className={styles.priceNumber}>${sellingPrice}</span>
//               {sellingPrice !== originalPrice ||
//               (recurring === SubscriptionRecurring.Yearly &&
//                 sellingPrice !== monthlySellingAmount) ? (
//                 <span className={styles.priceMonthlyNumber}>
//                   $
//                   {sellingPrice !== originalPrice
//                     ? originalPrice
//                     : monthlySellingAmount}
//                 </span>
//               ) : null}
//               <span className={styles.priceUnit}>
//                 / {t['com.affine.payment.cloud.pro.title.price-monthly-unit']()}
//               </span>
//               {/* {recurring === SubscriptionRecurring.Yearly ? (
//                 <span className={planTitleTitleCaption}>
//                   {t['com.affine.payment.cloud.pro.title.billed-yearly']()}
//                 </span>
//               ) : null} */}
//             </div>
//           );
//         },
//         benefits: proBenefits(t),
//       },
//     ],
//     [
//       SubscriptionPlan.Studio,
//       {
//         type: 'fixed',
//         plan: SubscriptionPlan.Studio,
//         monthlySellingAmount: '2',
//         monthlyOriginalAmount: '',
//         yearlySellingAmount: '2',
//         yearlyOriginalAmount: '',
//         monthlyPrice: 0,
//         yearlyPrice: 0,
//         name: t['com.affine.payment.cloud.studio-workspace.name'](),
//         description:
//           t['com.affine.payment.cloud.studio-workspace.description'](),
//         titleRenderer: (recurring, detail) => {
//           const sellingPrice =
//             recurring === SubscriptionRecurring.Yearly
//               ? detail.yearlySellingAmount
//               : detail.monthlySellingAmount;
//           const originalPrice =
//             recurring === SubscriptionRecurring.Yearly
//               ? detail.yearlyOriginalAmount
//               : detail.monthlyOriginalAmount;
//           console.log('aaaaaadetail', detail);
//           const monthlySellingAmount = detail.monthlySellingAmount;
//           return (
//             <>
//               <span className={styles.priceNumber}>${sellingPrice}</span>
//               {sellingPrice !== originalPrice ||
//               (recurring === SubscriptionRecurring.Yearly &&
//                 sellingPrice !== monthlySellingAmount) ? (
//                 <span className={styles.priceMonthlyNumber}>
//                   $
//                   {sellingPrice !== originalPrice
//                     ? originalPrice
//                     : monthlySellingAmount}
//                 </span>
//               ) : null}
//               <span className={styles.priceUnit}>
//                 / {t['com.affine.payment.cloud.pro.title.price-monthly-unit']()}
//               </span>
//               {/* {recurring === SubscriptionRecurring.Yearly ? (
//                 <span className={planTitleTitleCaption}>
//                   {t[
//                     'com.affine.payment.cloud.team-workspace.title.billed-yearly'
//                   ]()}
//                 </span>
//               ) : null} */}
//             </>
//           );
//         },
//         benefits: studioBenefits(t),
//       },
//     ],
//   ]);
// }

// const getRecurringLabel = ({
//   recurring,
//   t,
// }: {
//   recurring: SubscriptionRecurring;
//   t: ReturnType<typeof useI18n>;
// }) => {
//   return recurring === SubscriptionRecurring.Monthly
//     ? t['com.affine.payment.recurring-monthly']()
//     : t['com.affine.payment.recurring-yearly']();
// };

// export const CloudPlans = () => {
//   const t = useI18n();
//   const scrollWrapper = useRef<HTMLDivElement>(null);

//   const { authService, subscriptionService } = useServices({
//     AuthService,
//     SubscriptionService,
//   });

//   const cdnOnboardingUrl = useMemo(() => {
//     // Use CDN configuration
//     const env = getEnv();
//     return `https://wy-static.wenxiaobai.com/wenxiaobai-web/muset/${env}/isShowBlackFriday.json`;
//   }, []);
//   const { config: cdnConfig } = useCdnConfig(cdnOnboardingUrl);
//   const isShowBlackFriday = useMemo(
//     () => cdnConfig?.isShowBlackFriday,
//     [cdnConfig]
//   );
//   const yearlyDiscount = useMemo(() => {
//     return isShowBlackFriday ? '36' : '20';
//   }, [isShowBlackFriday]);

//   const prices = useLiveData(subscriptionService.prices.prices$);
//   const loggedIn = useLiveData(authService.session.status$) === 'authenticated';
//   const proSubscription = useLiveData(subscriptionService.subscription.pro$);
//   const isOnetimePro = useLiveData(
//     subscriptionService.subscription.isOnetimePro$
//   );

//   const [recurring, setRecurring] = useState<SubscriptionRecurring>(
//     proSubscription?.recurring ?? SubscriptionRecurring.Yearly
//   );

//   const planDetail = useMemo(() => {
//     const rawMap = getPlanDetail(t);
//     const clonedMap = new Map<SubscriptionPlan, FixedPrice | DynamicPrice>();

//     rawMap.forEach((detail, plan) => {
//       clonedMap.set(plan, { ...detail });
//     });
//     console.log('aaaaaaclonedMapprices', prices);

//     prices?.forEach(price => {
//       const detail = clonedMap.get(price.plan);
//       if (detail) {
//         detail.monthlySellingAmount = (price.monthlySellingAmount || 0).toFixed(
//           2
//         );
//         detail.monthlyPrice = price.monthlySellingAmount;
//         detail.monthlyOriginalAmount = (
//           price.monthlyOriginalAmount || 0
//         ).toFixed(2);
//         detail.monthlyProductId = price.monthlyId;
//         detail.yearlySellingAmount = (
//           price.yearlySellingAmount / 12 || 0
//         ).toFixed(2);
//         detail.yearlyPrice = price.yearlySellingAmount;
//         detail.yearlyProductId = price.yearlyId;
//         detail.yearlyOriginalAmount = (
//           price.yearlyOriginalAmount / 12 || 0
//         ).toFixed(2);
//       }
//     });
//     console.log('aaaaaaclonedMap', clonedMap);
//     return clonedMap;
//   }, [prices, t]);

//   const currentPlan = proSubscription?.plan ?? SubscriptionPlan.Free;
//   const isCanceled = !!proSubscription?.canceledAt;
//   const currentRecurring =
//     proSubscription?.recurring ?? SubscriptionRecurring.Monthly;

//   // auto scroll to current plan card with delay to avoid initial jump
//   // useEffect(() => {
//   //   if (!scrollWrapper.current) return;
//   //   const currentPlanCard = scrollWrapper.current.querySelector(
//   //     '[data-current="true"]'
//   //   );
//   //   const wrapperComputedStyle = getComputedStyle(scrollWrapper.current);
//   //   const left = currentPlanCard
//   //     ? currentPlanCard.getBoundingClientRect().left -
//   //       scrollWrapper.current.getBoundingClientRect().left -
//   //       parseInt(wrapperComputedStyle.paddingLeft)
//   //     : 0;
//   //   const appeared = scrollWrapper.current.dataset.appeared === 'true';

//   //   // Add delay to prevent initial jump to the right
//   //   const timeoutId = setTimeout(
//   //     () => {
//   //       const animationFrameId = requestAnimationFrame(() => {
//   //         if (!scrollWrapper.current) return;
//   //         scrollWrapper.current.scrollTo({
//   //           behavior: appeared ? 'smooth' : 'instant',
//   //           left,
//   //         });
//   //         scrollWrapper.current.dataset.appeared = 'true';
//   //       });
//   //       return () => {
//   //         cancelAnimationFrame(animationFrameId);
//   //       };
//   //     },
//   //     appeared ? 0 : 1000
//   //   ); // 1 second delay for initial load, immediate for subsequent changes

//   //   return () => {
//   //     clearTimeout(timeoutId);
//   //   };
//   // }, [recurring]);

//   // caption
//   const cloudCaption = loggedIn ? (
//     isCanceled ? (
//       <p>
//         {t['com.affine.payment.subtitle-canceled']({
//           plan: `${getRecurringLabel({
//             recurring: currentRecurring,
//             t,
//           })} ${currentPlan}`,
//         })}
//       </p>
//     ) : (
//       <p>
//         <Trans
//           plan={currentPlan}
//           i18nKey="com.affine.payment.subtitle-active"
//           values={{ currentPlan }}
//         >
//           You are currently on the {{ currentPlan }} plan. If you have any
//           questions, please contact our&nbsp;
//           <a
//             href="mailto:support@toeverything.info"
//             style={{ color: 'var(--affine-link-color)' }}
//           >
//             customer support
//           </a>
//           .
//         </Trans>
//       </p>
//     )
//   ) : (
//     <p>{t['com.affine.payment.subtitle-not-signed-in']()}</p>
//   );

//   // toggle
//   const cloudToggle = (
//     <div className={styles.recurringToggleWrapper}>
//       {isShowBlackFriday ? (
//         <div className={styles.recurringToggleBlackFriday}>
//           {t['com.affine.payment.cloud.pricing-plan.black-friday']()}
//         </div>
//       ) : null}
//       <div
//         className={`${styles.recurringToggleRecurring} ${recurring === SubscriptionRecurring.Monthly ? styles.recurringToggleRecurringActive : ''}`}
//         onClick={() => setRecurring(SubscriptionRecurring.Monthly)}
//       >
//         {t['com.affine.payment.cloud.pricing-plan.toggle-billed-monthly']()}
//       </div>
//       <div
//         className={`${styles.recurringToggleRecurring} ${recurring === SubscriptionRecurring.Yearly ? styles.recurringToggleRecurringActive : ''}`}
//         onClick={() => setRecurring(SubscriptionRecurring.Yearly)}
//       >
//         {t['com.affine.payment.cloud.pricing-plan.toggle-billed-yearly']()}
//         {yearlyDiscount ? (
//           <span className={styles.recurringToggleDiscount}>
//             {t['com.affine.payment.cloud.pricing-plan.toggle-discount']({
//               discount: yearlyDiscount,
//             })}
//           </span>
//         ) : null}
//       </div>
//       {/* <div>
//         <div className={styles.recurringToggleRecurring}>
//           <span>
//             {t['com.affine.payment.cloud.pricing-plan.toggle-billed-yearly']()}
//           </span>
//         </div>
//         {yearlyDiscount ? (
//           <div className={styles.recurringToggleDiscount}>
//             {t['com.affine.payment.cloud.pricing-plan.toggle-discount']({
//               discount: yearlyDiscount,
//             })}
//           </div>
//         ) : null}
//       </div>
//       <Switch
//         checked={recurring === SubscriptionRecurring.Yearly}
//         onChange={checked =>
//           setRecurring(
//             checked
//               ? SubscriptionRecurring.Yearly
//               : SubscriptionRecurring.Monthly
//           )
//         }
//       /> */}
//     </div>
//   );

//   const cloudScroll = (
//     <div className={styles.planCardsWrapper} ref={scrollWrapper}>
//       {Array.from(planDetail.values()).map(detail => {
//         return (
//           <PlanCard
//             key={detail.plan}
//             {...{ detail, recurring }}
//             isShowBlackFriday={isShowBlackFriday}
//           />
//         );
//       })}
//     </div>
//   );

//   const cloudSelect = (
//     <div className={styles.cloudSelect}>
//       <b>{t['com.affine.payment.cloud.pricing-plan.select.title']()}</b>
//       <span>{t['com.affine.payment.cloud.pricing-plan.select.caption']()}</span>
//     </div>
//   );

//   return (
//     <CloudPlanLayout
//       // caption={cloudCaption}
//       // select={cloudSelect}
//       toggle={cloudToggle}
//       scroll={cloudScroll}
//       scrollRef={scrollWrapper as RefObject<HTMLDivElement>}
//       lifetime={isOnetimePro ? null : <LifetimePlan />}
//     />
//   );
// };
import { Switch } from '@affine/component';
import {
  AuthService,
  SubscriptionService,
  UserCopilotQuotaService,
} from '@affine/core/modules/cloud';
import {
  SubscriptionPlan,
  SubscriptionRecurring,
  type PricesQuery,
} from '@affine/graphql';
import { Trans, useI18n } from '@affine/i18n';
import { AfFiNeIcon } from '@blocksuite/icons/rc';
import { useLiveData, useServices } from '@toeverything/infra';
import {
  type ReactNode,
  type RefObject,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { CloudPlanLayout } from './layout';
import { LifetimePlan } from './lifetime/lifetime-plan';
import { PlanCard } from './plan-card';
import * as styles from './style.css';
import { getEnv } from '@affine/core/modules/cloud/constant';
import { useCdnConfig } from '@affine/core/components/hooks/use-cdn-config';
import { usePreloadedBlackFriday } from '@affine/core/components/hooks/use-preloaded-black-friday';

type T = ReturnType<typeof useI18n>;

export type Benefits = Record<
  string,
  Array<{
    icon?: ReactNode;
    title: ReactNode;
    badge?: string;
  }>
>;
type BenefitsGetter = (t: T) => Benefits;
interface BasePrice {
  plan: SubscriptionPlan;
  name: string;
  description: string;
  benefits: Benefits;
}
export interface FixedPrice extends BasePrice {
  type: 'fixed';
  price: string;
  yearlyPrice: string;
  discount?: string;
  earlyAccessSpecial?: string;
  titleRenderer: (
    recurring: SubscriptionRecurring,
    detail: FixedPrice
  ) => ReactNode;
}

export interface DynamicPrice extends BasePrice {
  type: 'dynamic';
  contact: boolean;
  earlyAccessSpecial?: string;
  titleRenderer: (
    recurring: SubscriptionRecurring,
    detail: DynamicPrice
  ) => ReactNode;
}

const freeBenefits: BenefitsGetter = t => ({
  [t['com.affine.payment.cloud.free.benefit.g1']()]: ([1, 2, 3] as const).map(
    i => ({
      title:
        i <= 1 ? (
          <Trans
            i18nKey={`com.affine.payment.cloud.free.benefit.g1-${i}`}
            components={{ 1: <strong style={{ marginRight: '0.25em' }} /> }}
          />
        ) : (
          t[`com.affine.payment.cloud.free.benefit.g1-${i}`]()
        ),
      badge:
        i === 1
          ? t[`com.affine.payment.cloud.free.benefit.g1-${i}-badge`]()
          : '',
    })
  ),
});

const proBenefits: BenefitsGetter = t => ({
  [t['com.affine.payment.cloud.pro.benefit.g1']()]: (
    [1, 2, 3, 4, 5] as const
  ).map(i => ({
    title:
      i <= 3 ? (
        <Trans
          i18nKey={`com.affine.payment.cloud.pro.benefit.g1-${i}`}
          components={{
            1: (
              <strong
                style={{
                  marginRight: '0.25em',
                  ...(i === 3 ? { marginLeft: '0.25em' } : {}),
                }}
              />
            ),
          }}
        />
      ) : (
        t[`com.affine.payment.cloud.pro.benefit.g1-${i}`]()
      ),
    badge:
      i === 1 ? t[`com.affine.payment.cloud.pro.benefit.g1-${i}-badge`]() : '',
  })),
});

const studioBenefits: BenefitsGetter = t => ({
  [t['com.affine.payment.cloud.studio-workspace.benefit.g1']()]: (
    [1, 2, 3, 4, 5, 6] as const
  ).map(i => ({
    title:
      i <= 3 ? (
        <Trans
          i18nKey={`com.affine.payment.cloud.studio-workspace.benefit.g1-${i}`}
          components={{
            1: (
              <strong
                style={{
                  marginRight: '0.25em',
                  ...(i === 3 ? { marginLeft: '0.25em' } : {}),
                }}
              />
            ),
          }}
        />
      ) : (
        t[`com.affine.payment.cloud.studio-workspace.benefit.g1-${i}`]()
      ),
    badge:
      i === 1
        ? t[`com.affine.payment.cloud.studio-workspace.benefit.g1-${i}-badge`]()
        : '',
  })),
});

export function getPlanDetail(t: T, isShowBlackFriday: boolean) {
  return new Map<SubscriptionPlan, FixedPrice | DynamicPrice>([
    [
      SubscriptionPlan.Free,
      {
        type: 'fixed',
        plan: SubscriptionPlan.Free,
        price: '0',
        yearlyPrice: '0',
        name: t['com.affine.payment.cloud.free.name'](),
        description: t['com.affine.payment.cloud.free.description'](),
        titleRenderer: () => {
          return (
            <div className={styles.price}>
              <span className={styles.priceNumber}>$0</span>
              <span className={styles.priceUnit}>
                / {t['com.affine.payment.cloud.pro.title.price-monthly-unit']()}
              </span>
            </div>
          );
        },
        earlyAccessSpecial:
          t['com.affine.payment.cloud.free.earlyAccessSpecial'](),
        benefits: freeBenefits(t),
      },
    ],
    [
      SubscriptionPlan.Pro,
      {
        type: 'fixed',
        plan: SubscriptionPlan.Pro,
        price: '1',
        yearlyPrice: '1',
        name: t['com.affine.payment.cloud.pro.name'](),
        description: t['com.affine.payment.cloud.pro.description'](),
        earlyAccessSpecial:
          t['com.affine.payment.cloud.pro.earlyAccessSpecial'](),
        titleRenderer: (recurring, detail) => {
          const price =
            recurring === SubscriptionRecurring.Yearly
              ? isShowBlackFriday
                ? '12.80'
                : detail.yearlyPrice
              : detail.price;
          const monthlyPrice = detail.price;
          return (
            <div className={styles.price}>
              {/* {t['com.affine.payment.cloud.pro.title.price-monthly']({
                price: '$' + price,
              })} */}
              <span className={styles.priceNumber}>${price}</span>
              {recurring === SubscriptionRecurring.Yearly ? (
                <span className={styles.priceMonthlyNumber}>
                  ${monthlyPrice}
                </span>
              ) : null}
              <span className={styles.priceUnit}>
                / {t['com.affine.payment.cloud.pro.title.price-monthly-unit']()}
              </span>
              {/* {recurring === SubscriptionRecurring.Yearly ? (
                <span className={planTitleTitleCaption}>
                  {t['com.affine.payment.cloud.pro.title.billed-yearly']()}
                </span>
              ) : null} */}
            </div>
          );
        },
        benefits: proBenefits(t),
      },
    ],
    [
      SubscriptionPlan.Studio,
      {
        type: 'fixed',
        plan: SubscriptionPlan.Studio,
        price: '2',
        yearlyPrice: '2',
        name: t['com.affine.payment.cloud.studio-workspace.name'](),
        description:
          t['com.affine.payment.cloud.studio-workspace.description'](),
        titleRenderer: (recurring, detail) => {
          const price =
            recurring === SubscriptionRecurring.Yearly
              ? isShowBlackFriday
                ? '128.00'
                : detail.yearlyPrice
              : isShowBlackFriday
                ? '160.00'
                : detail.price;
          const monthlyPrice = detail.price;
          return (
            <>
              <div className={styles.price}>
                {/* {t['com.affine.payment.cloud.pro.title.price-monthly']({
                price: '$' + price,
              })} */}
                <span className={styles.priceNumber}>${price}</span>
                {recurring === SubscriptionRecurring.Yearly ||
                isShowBlackFriday ? (
                  <span className={styles.priceMonthlyNumber}>
                    ${monthlyPrice}
                  </span>
                ) : null}
                <span className={styles.priceUnit}>
                  /{' '}
                  {t['com.affine.payment.cloud.pro.title.price-monthly-unit']()}
                </span>
                {/* {recurring === SubscriptionRecurring.Yearly ? (
                <span className={planTitleTitleCaption}>
                  {t['com.affine.payment.cloud.pro.title.billed-yearly']()}
                </span>
              ) : null} */}
              </div>
            </>
          );
        },
        benefits: studioBenefits(t),
      },
    ],
  ]);
}

const getRecurringLabel = ({
  recurring,
  t,
}: {
  recurring: SubscriptionRecurring;
  t: ReturnType<typeof useI18n>;
}) => {
  return recurring === SubscriptionRecurring.Monthly
    ? t['com.affine.payment.recurring-monthly']()
    : t['com.affine.payment.recurring-yearly']();
};

export const CloudPlans = () => {
  const t = useI18n();
  const scrollWrapper = useRef<HTMLDivElement>(null);

  const { authService, subscriptionService } = useServices({
    AuthService,
    SubscriptionService,
  });

  const prices: PricesQuery['prices'] | null = useLiveData(
    subscriptionService.prices.prices$ ?? null
  );
  const loggedIn = useLiveData(authService.session.status$) === 'authenticated';
  const proSubscription = useLiveData(subscriptionService.subscription.pro$);
  const studioSubscription = useLiveData(
    subscriptionService.subscription.studio$
  );
  const isOnetimePro = useLiveData(
    subscriptionService.subscription.isOnetimePro$
  );

  const [recurring, setRecurring] = useState<SubscriptionRecurring>(
    studioSubscription?.recurring ??
      proSubscription?.recurring ??
      SubscriptionRecurring.Yearly
  );
  const { isShowBlackFriday } = usePreloadedBlackFriday();

  const planDetail = useMemo(() => {
    const rawMap = getPlanDetail(t, isShowBlackFriday);
    const clonedMap = new Map<SubscriptionPlan, FixedPrice | DynamicPrice>();

    rawMap.forEach((detail, plan) => {
      clonedMap.set(plan, { ...detail });
    });

    prices?.forEach(price => {
      const detail = clonedMap.get(price.plan);

      if (detail?.type === 'fixed') {
        detail.price = ((price.amount ?? 0) / 100).toFixed(2);
        detail.yearlyPrice = ((price.yearlyAmount ?? 0) / 100 / 12).toFixed(2);
        detail.discount =
          price.yearlyAmount && price.amount
            ? (
                Math.round(
                  (1 - price.yearlyAmount / 12 / price.amount) * 100 * 100
                ) / 100
              ).toString()
            : undefined;
      }
    });

    return clonedMap;
  }, [prices, t, isShowBlackFriday]);

  const currentPlan =
    studioSubscription?.plan ?? proSubscription?.plan ?? SubscriptionPlan.Free;
  const isCanceled = !!proSubscription?.canceledAt;
  const currentRecurring =
    studioSubscription?.recurring ??
    proSubscription?.recurring ??
    SubscriptionRecurring.Monthly;
  const yearlyDiscount = useMemo(() => {
    return isShowBlackFriday ? '36' : '20';
  }, [isShowBlackFriday]);

  // // auto scroll to current plan card
  // useEffect(() => {
  //   if (!scrollWrapper.current) return;
  //   const currentPlanCard = scrollWrapper.current.querySelector(
  //     '[data-current="true"]'
  //   );
  //   const wrapperComputedStyle = getComputedStyle(scrollWrapper.current);
  //   const left = currentPlanCard
  //     ? currentPlanCard.getBoundingClientRect().left -
  //       scrollWrapper.current.getBoundingClientRect().left -
  //       parseInt(wrapperComputedStyle.paddingLeft)
  //     : 0;
  //   const appeared = scrollWrapper.current.dataset.appeared === 'true';
  //   const animationFrameId = requestAnimationFrame(() => {
  //     if (!scrollWrapper.current) return;
  //     scrollWrapper.current.scrollTo({
  //       behavior: appeared ? 'smooth' : 'instant',
  //       left,
  //     });
  //     scrollWrapper.current.dataset.appeared = 'true';
  //   });
  //   return () => {
  //     cancelAnimationFrame(animationFrameId);
  //   };
  // }, [recurring]);

  // caption
  const cloudCaption = loggedIn ? (
    isCanceled ? (
      <p>
        {t['com.affine.payment.subtitle-canceled']({
          plan: `${getRecurringLabel({
            recurring: currentRecurring,
            t,
          })} ${currentPlan}`,
        })}
      </p>
    ) : (
      <p>
        <Trans
          plan={currentPlan}
          i18nKey="com.affine.payment.subtitle-active"
          values={{ currentPlan }}
        >
          You are currently on the {{ currentPlan }} plan. If you have any
          questions, please contact our&nbsp;
          <a
            href="mailto:support@toeverything.info"
            style={{ color: 'var(--affine-link-color)' }}
          >
            customer support
          </a>
          .
        </Trans>
      </p>
    )
  ) : (
    <p>{t['com.affine.payment.subtitle-not-signed-in']()}</p>
  );

  // toggle

  const cloudToggle = (
    <div className={styles.recurringToggleWrapper}>
      {isShowBlackFriday ? (
        <div className={styles.recurringToggleBlackFriday}>
          {t['com.affine.payment.cloud.pricing-plan.black-friday']()}
        </div>
      ) : null}
      <div
        className={`${styles.recurringToggleRecurring} ${recurring === SubscriptionRecurring.Monthly ? styles.recurringToggleRecurringActive : ''}`}
        onClick={() => setRecurring(SubscriptionRecurring.Monthly)}
      >
        {t['com.affine.payment.cloud.pricing-plan.toggle-billed-monthly']()}
      </div>
      <div
        className={`${styles.recurringToggleRecurring} ${recurring === SubscriptionRecurring.Yearly ? styles.recurringToggleRecurringActive : ''}`}
        onClick={() => setRecurring(SubscriptionRecurring.Yearly)}
      >
        {t['com.affine.payment.cloud.pricing-plan.toggle-billed-yearly']()}
        {yearlyDiscount ? (
          <span className={styles.recurringToggleDiscount}>
            {t['com.affine.payment.cloud.pricing-plan.toggle-discount']({
              discount: yearlyDiscount,
            })}
          </span>
        ) : null}
      </div>
      {/* <div>
        <div className={styles.recurringToggleRecurring}>
          <span>
            {t['com.affine.payment.cloud.pricing-plan.toggle-billed-yearly']()}
          </span>
        </div>
        {yearlyDiscount ? (
          <div className={styles.recurringToggleDiscount}>
            {t['com.affine.payment.cloud.pricing-plan.toggle-discount']({
              discount: yearlyDiscount,
            })}
          </div>
        ) : null}
      </div>
      <Switch
        checked={recurring === SubscriptionRecurring.Yearly}
        onChange={checked =>
          setRecurring(
            checked
              ? SubscriptionRecurring.Yearly
              : SubscriptionRecurring.Monthly
          )
        }
      /> */}
    </div>
  );

  const cloudScroll = (
    <div className={styles.planCardsWrapper} ref={scrollWrapper}>
      {Array.from(planDetail.values()).map(detail => {
        return (
          <PlanCard
            key={detail.plan}
            {...{ detail, recurring }}
            isShowBlackFriday={isShowBlackFriday}
          />
        );
      })}
    </div>
  );

  const cloudSelect = (
    <div className={styles.cloudSelect}>
      <b>{t['com.affine.payment.cloud.pricing-plan.select.title']()}</b>
      <span>{t['com.affine.payment.cloud.pricing-plan.select.caption']()}</span>
    </div>
  );

  return (
    <CloudPlanLayout
      // caption={cloudCaption}
      // select={cloudSelect}
      toggle={cloudToggle}
      scroll={cloudScroll}
      scrollRef={scrollWrapper as RefObject<HTMLDivElement>}
      lifetime={isOnetimePro ? null : <LifetimePlan />}
    />
  );
};
